// resources/js/src/services/friendship.api.ts
import { request } from "./api";

export const friendshipApi = {
  sendRequest: (userId: number | string) =>
    request<null>("POST", `/community/friendships/requests`, { user_id: userId }),

  cancelRequest: (userId: number | string) =>
    request<null>("DELETE", `/community/friendships/requests/${userId}`),

  acceptRequest: (userId: number | string) =>
    request<null>("POST", `/community/friendships/requests/${userId}/accept`),

  declineRequest: (userId: number | string) =>
    request<null>("POST", `/community/friendships/requests/${userId}/decline`),

  removeFriend: (userId: number | string) =>
    request<null>("DELETE", `/community/friendships/${userId}`),

  // ✅ جديد
  block: (userId: number | string) =>
    request<null>("POST", `/community/blocks/${userId}`),

  unblock: (userId: number | string) =>
    request<null>("DELETE", `/community/blocks/${userId}`),
};